import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from "@mui/material";

const DeleteDialog=(props)=>{
	return ( <Dialog
		open={props.openConfirm}
		onClose={() => props.setOpenConfirm(false)}
		aria-labelledby="alert-dialog-title"
		aria-describedby="alert-dialog-description"
	>
		<DialogTitle id="alert-dialog-title">
			Are you sure you want to delete {props.type}?
		</DialogTitle>
		<DialogContent>
			<DialogContentText id="alert-dialog-description">
				All cards with this {props.type} would effected.
			</DialogContentText>
		</DialogContent>
		<DialogActions>
			<Button onClick={() => props.setOpenConfirm(false)}>Cancel</Button>
			<Button onClick={()=>{
				props.deleteGameHandler(props.questionIndex)
				props.setOpenConfirm(false)
			}} autoFocus>
				Delete
			</Button>
		</DialogActions>
	</Dialog>)
}
export default DeleteDialog;
